<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Bitiş')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="salesPersonCode"
          label="Plasiyer"
          filled
          solo
          dense
          :items="salesPersonList"
          :item-text="item => item.name"
          :item-value="item => item.code"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'stock'"
          @itemChange="(e) => (selectedStock = e)"
          :label="'Stok'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue"
          label="Grup Kodu"
          :items="groupCodeList"
          item-text="name"
          item-value="code"
          filled
          clearable
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 1"
          v-model="groupCodeValue1"
          :items="groupCodeList1"
          item-text="name"
          item-value="code"
          filled
          clearable
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 2"
          v-model="groupCodeValue2"
          :items="groupCodeList2"
          item-text="name"
          item-value="code"
          filled
          clearable
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 3"
          v-model="groupCodeValue3"
          :items="groupCodeList3"
          item-text="name"
          item-value="code"
          filled
          solo
          clearable
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 4"
          v-model="groupCodeValue4"
          :items="groupCodeList4"
          item-text="name"
          item-value="code"
          filled
          solo
          clearable
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 5"
          v-model="groupCodeValue5"
          :items="groupCodeList5"
          item-text="name"
          item-value="code"
          filled
          solo
          clearable
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="reportDbName"
          label="Şirket Adı"
          filled
          solo
          dense
          :items="companyList"
          item-text="name"
          clearable
          item-value="name"
      >
      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="branchcode"
          label="Şube Kodu"
          filled
          solo
          dense
          :items="branchList"
          item-value="code"
          item-text="name"
      >
      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import {mapActions, mapMutations, mapState} from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  name: "PlasiyerUrunSatis",
  components: {SearchSelect},
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      groupCodeList:[],
      groupCodeList1:[],
      groupCodeList2:[],
      groupCodeList3:[],
      groupCodeList4:[],
      groupCodeList5:[],
      groupCodeValue:null,
      groupCodeValue1:null,
      groupCodeValue2:null,
      groupCodeValue3:null,
      groupCodeValue4:null,
      groupCodeValue5:null,
      reportDbName: null,
      selectedStock: null,
      stockSearchText: null,
      searchStockLoading: false,
      stockSearchResult:[],
      searchStockTimeout: null,
      salesPersonCode:null,
      branchcode:null,
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },

  mounted() {
    this.getBranchList();
    this.getCodesList();
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    });
    this.fetchCompanyList({
      params: {

      },
      body: {

      }
    })
  },
  computed:{
    ...mapState("current",["salesPersonList"]),
    ...mapState("auth",["user"]),
    ...mapState("company",["companyList","branchList"])
  },
  methods:{
    ...mapActions("current", ["fetchSalesPersonList"]),
    ...mapActions("company", ["fetchCompanyList","fetchBranchList"]),
    ...mapActions("stock", ["fetchStockList","fetchStockCodes"]),
    ...mapMutations("company", ['setBranchList']),

    formattedDate,
    validationMessages,
    async getBranchList() {
      await this.fetchBranchList({
        params: {},
        body: {}
      });
      let tempBranchList = this.branchList.slice();
      tempBranchList.unshift({code: null, name: 'Tüm Şubeler'})
      this.setBranchList(tempBranchList);
    },
    async getCodesList(){
      let codeList = [1,2,3,4,5,6];
      for (let i = 0; i < codeList.length; i++) {
        let requestParams = {};
        switch (codeList[i]){
          case null:
            requestParams.params = {};
            requestParams.body = {}
            break;
          default:
            requestParams.params = {tableType: codeList[i]};
            requestParams.body = {}
            break;
        }
        let result = await this.fetchStockCodes(requestParams);
        switch (codeList[i]){
          case 1:
            this.groupCodeList = result;
            break;
          case 2:
            this.groupCodeList1 = result;
            break;
          case 3:
            this.groupCodeList2 = result;
            break;
          case 4:
            this.groupCodeList3 = result;
            break;
          case 5:
            this.groupCodeList4 = result;
            break;
          case 6:
            this.groupCodeList5 = result;
            break;

        }
      }
    },
    filterReport(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          StockCode: this.selectedStock,
          GroupCode: this.groupCodeValue,
          Code1: this.groupCodeValue1,
          Code2: this.groupCodeValue2,
          Code3: this.groupCodeValue3,
          Code4: this.groupCodeValue4,
          Code5: this.groupCodeValue5,
          SalesPersonCode: this.salesPersonCode,
          ReportDbName: this.reportDbName,
          BranchCode: this.branchcode,

        };
        this.$emit("reportFilterChange",this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
    async searchStockList() {
      this.stockSearchResult = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 30,
          userId: this.user.UserId,
        },
        body: {
          stock: this.stockSearchText,
          GenericCategories: null
        },
        onlyData: true,
        loading: false
      });
      this.searchStockLoading = false

    }
  },
  watch:{
    stockSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        if(this.searchStockTimeout)
          clearTimeout(this.searchStockTimeout);
        this.searchStockLoading = true
        this.searchStockTimeout = setTimeout(() => {
          this.searchStockList();
        },3000);
      }
    }
  }
}
</script>

<style scoped>

</style>